//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emptyCell from "../components/emptyCell";

export default {
    name: "my-appoint",
    components: {
        emptyCell,
    },
    data() {
        return {
            leftIco: require('@/assets/img/ico-building.png'),
            list: [],
            loading: false,
            searchInput: {},
            pageSize: 30,
            currentPage: 1,
            show: false,
            memberInfo: {}
        }
    },
    methods: {
        getPage() {
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.searchInput.memberId = this.memberInfo.id;
            abp.ajax.post('/api/services/app/DeliveryRecord/SearchDeliveryRecords', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
            }).finally(() => {
                this.loading = false;
            });
        },
        async getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                this.memberInfo = this.$store.state.member.memberInfo;
                this.getPage();
            }).finally(() => {
                this.$toast.clear();
            });
        },
    },
    created() {
        this.getMyMember();
    }
}
